import { Editor, Location, Transforms } from 'slate';

export function insertText(editor: Editor, text: string, options?: {
    at?: Location;
    voids?: boolean;
}) {
    return Transforms.insertText(editor, text, options);
}
